<template>
  <div class="card">
    <!-- Card Header -->
    <div class="card-header card-header-stretch">
      <h3 class="card-title">{{ $t('society.title') }}</h3>
    </div>

    <!-- Card Body -->
    <div class="card-body">
        <div>
          <div class="d-flex justify-content-end mb-5">
            <button @click="addOrUpdateSociety" class="btn btn-sm btn-primary fw-bolder" :disabled="isLoading">
              <span class="indicator-label" v-if="!isLoading">
                <i class="bi bi-check2 me-1"></i>
                {{ $t('button.save') }}
              </span>
              <span class="indicator-progress" v-if="isLoading">
                {{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>

          <!-- Infos communes à toutes les boutiques ; coordonnées et logo : détail de chaque boutique -->
          <div class="notice d-flex bg-light-primary rounded border-primary border border-dashed p-4 mb-8">
            <i class="bi bi-info-circle fs-2 text-primary me-3"></i>
            <div class="fs-7 text-gray-700">
              Ces informations concernent l'entreprise et s'appliquent à <strong>toutes vos boutiques</strong>.
              L'adresse, les téléphones, le logo et le favicon sont propres à chaque boutique :
              modifiez-les depuis <strong>Boutiques → détail de la boutique → Coordonnées et identité</strong>.
            </div>
          </div>

          <!-- Section: Informations générales -->
          <div class="row mb-8">
            <div class="col-12">
              <h4 class="fw-bold text-dark mb-5">
                <i class="bi bi-building me-2 text-primary"></i>
                {{ $t('society.sections.general_info') || 'Informations générales' }}
              </h4>
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="required form-label">{{ $t('society.forms.name') }}</label>
              <input type="text" v-model="society.society_name" class="form-control form-control-solid" :placeholder="$t('society.forms.name')" required />
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="required form-label">{{ $t('society.forms.email') }}</label>
              <input type="email" v-model="society.society_email" class="form-control form-control-solid" :placeholder="$t('society.forms.email')" required />
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="form-label">{{ $t('society.forms.ifu_number') }}</label>
              <input type="text" v-model="society.ifu_number" class="form-control form-control-solid" :placeholder="$t('society.forms.ifu_number')" />
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="form-label">{{ $t('society.forms.rccm_number') }}</label>
              <input type="text" v-model="society.rccm_number" class="form-control form-control-solid" :placeholder="$t('society.forms.rccm_number')" />
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="form-label">{{ $t('society.forms.website') }}</label>
              <input type="text" v-model="society.website" class="form-control form-control-solid" :placeholder="$t('society.forms.website')" />
            </div>

            <div class="col-md-6 col-sm-12 mb-4">
              <label class="form-label">{{ $t('society.forms.fax') }}</label>
              <input type="text" v-model="society.fax" class="form-control form-control-solid" :placeholder="$t('society.forms.fax')" />
            </div>

            <div class="col-12 mb-4">
              <label class="form-label">{{ $t('society.forms.description') }}</label>
              <textarea v-model="society.description" class="form-control form-control-solid" rows="4" :placeholder="$t('society.forms.description')"></textarea>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from "vuex"
import i18n from "@/plugins/i18n"

const store = useStore()

// ========== Informations de l'entreprise (communes à toutes les boutiques) ==========
const society = ref({
  society_name: '',
  society_email: '',
  ifu_number: '',
  rccm_number: '',
  description: '',
  website: '',
  fax: '',
})

const isLoading = ref(false)

function loadSocietyData() {
  isLoading.value = true
  store.dispatch('core/getSocietyInfo', { key: 'default' })
    .then(response => {
      if (response.data && response.data.societyInfo) {
        const data = response.data.societyInfo
        for (const key in society.value) {
          society.value[key] = data[key] ?? ''
        }
      }
    })
    .catch(err => console.error(err))
    .finally(() => { isLoading.value = false })
}

async function addOrUpdateSociety() {
  isLoading.value = true

  const formData = new FormData()
  for (const key in society.value) {
    formData.append(key, society.value[key] ?? '')
  }

  store.dispatch('core/updateSocietyInfo', formData)
    .then(res => {
      window.toastr['success'](i18n.global.t('notification.society_updated'))
    })
    .catch(err => {
      window.toastr['error'](i18n.global.t('notification.error'))
      console.error(err)
    })
    .finally(() => { isLoading.value = false })
}

// ========== Initialisation ==========
onMounted(() => {
  loadSocietyData()
})
</script>
